import Tween from "tween.ts";
import Animation from "./Animation";


export default class CustomDelay extends Animation {
  private Anim = Animation.getInstance();
	private isStopped: boolean = false;
  constructor(delay:number, resolve: () => void) {
    super();

    this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, () => this.isStopped = true);

    if(this.Anim.getIsCancelled()) {
      resolve();
      return 
    };
      
    const time = { d: 0 };
    new Tween.Tween({ ...time })
      .to({ d: delay }, delay)
      .easing(Tween.Easing.Linear.None)
      .onUpdate(time => {
        if(this.isStopped) {
          resolve();
          return
        }
      })
      .onComplete(() => resolve())
      .start()
  }
}